// extracted by mini-css-extract-plugin
export default {"DiscountItem":"DiscountItem-styles__DiscountItem__PZp1H","DiscountItem--compact":"DiscountItem-styles__DiscountItem--compact__g7btU"};